import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink } from "lucide-react";

export default function Resources() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState("All");

  useEffect(() => {
    api.get("/resources").then(({ data }) => setItems(data));
  }, []);

  const categories = useMemo(() => ["All", ...Array.from(new Set(items.map((i) => i.category)))], [items]);
  const filtered = active === "All" ? items : items.filter((i) => i.category === active);

  return (
    <div className="max-w-7xl mx-auto px-6 py-10" data-testid="resources-page">
      <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">Autism Resources</h1>
      <p className="text-slate-600 mt-2 max-w-2xl">Trusted links for ABA therapy, school support, hospital and clinic services, WIC and county assistance, parent guides, speech and safety planning.</p>

      <div className="flex gap-2 flex-wrap my-7">
        {categories.map((c) => (
          <button key={c} data-testid={`resource-cat-${c}`} onClick={() => setActive(c)} className={`px-4 py-2 rounded-full text-sm font-bold ${active === c ? "bg-pink-500 text-white" : "bg-white ring-1 ring-pink-100 text-slate-700 hover:bg-pink-50"}`}>{c}</button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map((r) => (
          <a key={r.id} href={r.url} target="_blank" rel="noreferrer" data-testid={`resource-${r.id}`} className="card-soft p-5 group">
            <div className="text-xs uppercase tracking-wider text-purple-600 font-bold">{r.category}</div>
            <h3 className="font-display font-bold text-lg text-slate-900 mt-2 group-hover:text-pink-600">{r.name}</h3>
            <p className="text-sm text-slate-600 mt-2">{r.blurb}</p>
            <div className="mt-4 inline-flex items-center gap-1 text-pink-600 font-semibold text-sm">Visit <ExternalLink className="h-3.5 w-3.5" /></div>
          </a>
        ))}
      </div>
    </div>
  );
}
